import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CHECKOUTS_RULE_EDITOR_CLASS_NAME = 'CheckoutsRuleEditor';
export const CHECKOUTS_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type CheckoutsRuleEditorClassSlot =
	(typeof CHECKOUTS_RULE_EDITOR_CLASS_SLOTS)[number];

export interface CheckoutsRuleEditorClasses {
	root: string;
}

export type CheckoutsRuleEditorClassKey = keyof CheckoutsRuleEditorClasses;

export const getCheckoutsRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(CHECKOUTS_RULE_EDITOR_CLASS_NAME, slot);

export const checkoutsRuleEditorClasses: CheckoutsRuleEditorClasses =
	generateUtilityClasses(CHECKOUTS_RULE_EDITOR_CLASS_NAME, ['root']);

export default checkoutsRuleEditorClasses;
